import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded';
import Box from '@mui/material/Box';
import { DEFAULT_ICON_CLASS_NAME } from '../../theme/constants/icon';

const IconStackOverlay = ({ children, IconComponent, iconProps }) => (
  <Stack
    id="icon-stack-overlay"
    mt={4}
    width="100%"
    height="50%"
    alignItems="center"
    justifyContent="center"
    style={{ zIndex: 5, position: 'relative' }}
    spacing={1}
  >
    <Box sx={{ minWidth: 40, height: 'auto', mb: 1 }}>
      <IconComponent
        {...iconProps}
      />
    </Box>
    {children}
  </Stack>
);

IconStackOverlay.propTypes = {
  children: PropTypes.node.isRequired,
  IconComponent: PropTypes.elementType,
  iconProps: PropTypes.shape({}),
};

IconStackOverlay.defaultProps = {
  IconComponent: DescriptionRoundedIcon,
  iconProps: {
    className: DEFAULT_ICON_CLASS_NAME,
    sx: {
      width: 40,
      height: 'auto',
    },
  },
};

export default IconStackOverlay;
